import type { Dispatch, SetStateAction } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Endpoint, PaymentOption, QueryKey } from '@/constants';
import { useCheckout } from '@/contexts/checkoutContext';
import { getData } from '@/utils/getData';

export const useGetMerchantSessionKey = (
  setMerchantSessionKey: Dispatch<SetStateAction<string>>,
) => {
  const queryClient = useQueryClient();
  const { paymentOption } = useCheckout();

  const { data, isSuccess } = useQuery({
    enabled: paymentOption === PaymentOption.CreditCard,
    queryFn: getData(Endpoint.SagePayGetMerchantSessionKey),
    queryKey: [QueryKey.SagePayGetMerchantSessionKey],
  });

  return {
    getMerchantSessionKey: (currentKey: string) => {
      if (currentKey) {
        queryClient.invalidateQueries({
          queryKey: [QueryKey.SagePayGetMerchantSessionKey],
        });
      }

      if (isSuccess) {
        const key = data?.MerchantSessionKey ?? '';
        setMerchantSessionKey(key);
        return key;
      }

      return '';
    },
    isSuccess,
  };
};
